module.exports = __webpack_public_path__ + "img/selected0-min.1b403bd8.png";